import { ZoomUser as ZoomUserDto } from "./client";
import { ZoomUser } from "./OneOnOnes.types";

export const dtoToZoomUser = (dto: ZoomUserDto): ZoomUser => ({ ...dto });
